import useMediaQuery from "@material-ui/core/useMediaQuery";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { nbfgetOrderStatus } from "../../api/restApi";
import CustomAutocomplete from "../../components/AutoComplete";
import InvoiceModal from "../../components/modals/InvoiceModal";
import OverlayLoader from "../../components/modals/OverlayLoader";
import { ordersData } from "../../store/reducer/ordersSlice";
import { useAppSelector } from "../../utils/hooks";
import Tabs from "./tabs";

const OrderStatus = () => {
  const isMediumScreen = useMediaQuery("(min-width: 960px)");
  const [orderByCustomer, setOrderByCustomer] = useState("");
  const [openInvoice, setOpenInvoice] = useState(false);
  const [open, setOpen] = useState(true); // Set initial loader state to true
  const { ordersDate } = useAppSelector(ordersData);
  const [orderByStatusData, setOrderByStatusData] = useState();
  const [sortedOrdersDate, setSortedOrdersDate] = useState([]);
  const name = useSelector((state) => state.currentUser.name);
  const role = useSelector((state) => state.currentUser.role);
  const [selectedDate, setSelectedDate] = useState("");

  useEffect(() => {
    // Get the current month and year
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();

    // Filter ordersDate to include only dates from the current month
    const currentMonthDates = ordersDate.filter(date => {
      const dateObj = new Date(date);
      
      const twoMonthsAgo = new Date();
      twoMonthsAgo.setMonth(currentMonth - 2);

      return true
    });

    // Sort filtered dates and set sortedOrdersDate
    const sortedDates = currentMonthDates.sort((a, b) => new Date(b) - new Date(a));
    setSortedOrdersDate(sortedDates);

    // Set default selectedDate to the latest date in the current month
    if (sortedDates.length > 0) {
      setSelectedDate(sortedDates[0]);
      handleStatus(sortedDates[0]);
    }

    // Hide loader after fetching dates
    setOpen(false);
  }, [ordersDate]);

  const handleSelectDate = async (event, newValue) => {
    setSelectedDate(newValue);
    handleStatus(newValue);
  };

  const handleStatus = async (newValue) => {
    setOpen(true);
    try {
      const nbfOrderStatus = await nbfgetOrderStatus(newValue);

      const filteredOrders = nbfOrderStatus.order.filter(
        (order) => order.customerId == name
      );
      const filteredProduction = nbfOrderStatus.production.filter(
        (production) => production.customerId == name
      );
      const filteredDelivered = nbfOrderStatus.delivered.filter(
        (delivered) => delivered.customerId == name
      );

      const output = {
        production: filteredProduction,
        order: filteredOrders,
        delivered: filteredDelivered,
      };

      if (role == "cs") setOrderByStatusData(output);
      else setOrderByStatusData(nbfOrderStatus);
      setOpen(false);
    } catch {
      setOpen(false);
    }
  };

  return (
    <div>
      <Box sx={{ flexGrow: 0 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <Card variant="outlined" sx={{ width: "100%" }}>
              <CardContent>
                <Stack alignItems="center">
                  <CustomAutocomplete
                    id="combo-box-demo"
                    options={sortedOrdersDate}
                    value={selectedDate}
                    onChange={handleSelectDate}
                    label="Select a date"
                  />
                </Stack>
                <Tabs
                  orderByStatusData={orderByStatusData}
                  selectedDate={selectedDate}
                  handleSelectDate={handleSelectDate}
                  handleStatus={handleStatus}
                />
                {orderByCustomer && (
                  <InvoiceModal
                    openInvoice={openInvoice}
                    orderByCustomer={orderByCustomer}
                    setOpenInvoice={setOpenInvoice}
                  />
                )}
                <OverlayLoader open={open} />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default OrderStatus;
